import { FC } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { useSpecificCountry } from "../../dataHooks/countryQueries";
import { SignOffPage } from "./signOffPage";

type Params = {
  id?: string;
};

export const CountrySignOff: FC = () => {
  const { id } = useParams<Params>();

  const { data: country, isLoading } = useSpecificCountry(id, {
    // Poll while on the sign-off page so a VP signing off picks up a rejection or another
    // signature made by someone else without needing a manual reload.
    refetchInterval: 30000
  });

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  if (country === undefined) {
    return (
      <Box sx={{ padding: 3 }}>
        <Alert severity="error">Country addition not found</Alert>
      </Box>
    );
  }

  return (
    <Box flex={1}>
      <SignOffPage specificCountry={country} key={country.id} />
    </Box>
  );
};
